import { createClient } from '@supabase/supabase-js';

const rawSupabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '';
const shouldUseSupabaseProxy =
  import.meta.env.VITE_SUPABASE_USE_PROXY === 'true' ||
  (
    typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  );
const supabaseUrl = shouldUseSupabaseProxy && typeof window !== 'undefined'
  ? `${window.location.origin}/api/supabase`
  : rawSupabaseUrl;

export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';
export const isSupabaseAuthConfigured = Boolean(rawSupabaseUrl && supabaseKey);
export const isGoogleSignInConfigured = Boolean(isSupabaseAuthConfigured && googleClientId);

export const supabase = isSupabaseAuthConfigured
  ? createClient(supabaseUrl, supabaseKey, {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: false,
        persistSession: true,
      },
    })
  : null;
